import { render, staticRenderFns } from "./UserCards.vue?vue&type=template&id=ff584532&scoped=true&"
import script from "./UserCards.vue?vue&type=script&lang=js&"
export * from "./UserCards.vue?vue&type=script&lang=js&"
import style0 from "./UserCards.vue?vue&type=style&index=0&id=ff584532&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff584532",
  null
  
)

export default component.exports